import { FunctionComponent, SVGProps, PropsWithChildren } from "react";
import Link from "next/link";
import { Button } from "@mantine/core";

const FeatureCard: FunctionComponent<
  {
    name: string;
    intro: string;
    btnText: string;
    Icon: FunctionComponent<SVGProps<SVGSVGElement>>;
    onClick: any;
    disable?: boolean;
  } & PropsWithChildren
> = ({ name, intro, btnText, Icon, onClick, children, disable }) => {
  return (
    <div className="pt-[55px] pb-[61px] px-9 rounded-lg bg-featureCardBg bg-cover relative">
      <Icon
        className="fill-[rgba(255,255,255,0.15)] absolute right-6 top-0 w-fit "
        style={{
          transform: "rotate(10deg) scale(1.2)",
        }}
      ></Icon>
      <div className="font-semibold text-dark1 text-2xl">{name}</div>
      <div className="font-normal text-sm text-dark1 mt-4 whitespace-pre-line">
        {intro}
      </div>
      <div className="flex items-center mt-10">
        <Button
          variant="filled"
          radius="xl"
          size="md"
          classNames={{
            root: "w-[165px]",
          }}
          onClick={onClick}
          disabled={!!disable}
        >
          {btnText}
        </Button>
        {children}
      </div>
    </div>
  );
};

export default FeatureCard;
